(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nt-artist-direction"] && !Shopify.designMode) return;
  try {
    
function ntArtistMotion(){
 document.querySelectorAll('[data-process-film]').forEach(video=>{
 const toggle=video.parentElement.querySelector('[data-film-toggle]');
 if(!toggle||video.dataset.filmReady)return;
 video.dataset.filmReady='true';
 const update=()=>{toggle.textContent=video.paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(!video.paused));};
 video.addEventListener('play',update);video.addEventListener('pause',update);
 toggle.addEventListener('click',()=>{if(video.paused)video.play().catch(()=>{});else video.pause();});
 update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ntArtistMotion);else ntArtistMotion();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-chrome"] && !Shopify.designMode) return;
  try {
    

function ntInit(){
 const dialog=document.getElementById('nt-lightbox');
 let opener=null;
 const openImage=(link)=>{
  if(!dialog||typeof dialog.showModal!=='function')return false;
  opener=link;
  document.getElementById('nt-lightbox-image').src=link.href;
  document.getElementById('nt-lightbox-image').alt=link.dataset.title||'';
  document.getElementById('nt-lightbox-title').textContent=link.dataset.title||'';
  document.getElementById('nt-lightbox-note').textContent=link.dataset.note||'';
  const details=document.getElementById('nt-lightbox-details');
  details.textContent=[link.dataset.medium,link.dataset.year,link.dataset.dimensions,link.dataset.location,link.dataset.status].filter(Boolean).join(' · ');
  const project=document.getElementById('nt-lightbox-project');project.hidden=!link.dataset.project;if(link.dataset.project)project.href=link.dataset.project;
  if(!dialog.open)dialog.showModal();
  return true;
 };
 document.querySelectorAll('[data-lightbox]').forEach(link=>link.addEventListener('click',event=>{
  if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  if(link.closest('.nt-archive[data-archive-view=index]'))return;
  if(openImage(link)){event.preventDefault();if(link.dataset.id)history.replaceState(null,'','#'+link.dataset.id);}
 }));
 if(dialog){
  dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{if(opener&&opener.dataset.id&&location.hash==='#'+opener.dataset.id)history.replaceState(null,'',location.pathname+location.search);if(opener)opener.focus({preventScroll:true});});
 }
 const hash=location.hash.slice(1);
 if(hash){const target=Array.from(document.querySelectorAll('[data-id]')).find(el=>el.dataset.id===hash);if(target)openImage(target);}
 document.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
  const section=button.closest('.nt-gallery-section');
  section.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  section.querySelectorAll('[data-kind]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.kind!==button.dataset.filter;});
 }));
 const variant=document.getElementById('nt-variant');
 if(variant)variant.addEventListener('change',()=>{
  const option=variant.selectedOptions[0];const button=document.querySelector('[data-add]');
  document.querySelector('[data-price]').textContent=option.dataset.price;
  button.disabled=option.dataset.available!=='true';
  button.textContent=button.disabled?button.dataset.unavailableText:button.dataset.availableText;
  const url=new URL(location.href);url.searchParams.set('variant',variant.value);history.replaceState(null,'',url);
 });
 document.querySelectorAll('[data-product-inquiry]').forEach(link=>link.href='/pages/contact?work='+encodeURIComponent(link.dataset.productInquiry));
 const params=new URLSearchParams(location.search);
 const inquiry=params.get('work'), interest=params.get('interest')||(inquiry?'originals':'');
 const select=document.getElementById('nt-type'), context=document.getElementById('nt-inquiry-context');
 if(inquiry&&context){document.getElementById('nt-inquiry-title').textContent=inquiry;document.getElementById('nt-work-field').value=inquiry;context.hidden=false;}
 const imageParam=params.get('image'), inquiryImage=document.getElementById('nt-inquiry-image');
 if(imageParam&&inquiryImage&&inquiry){try{const imageUrl=new URL(imageParam,location.origin);if(imageUrl.protocol==='https:'&&(imageUrl.hostname==='cdn.shopify.com'||imageUrl.hostname==='nottravis.com')){inquiryImage.src=imageUrl.href;inquiryImage.alt=inquiry;inquiryImage.hidden=false;}}catch(error){}}
 const source=params.get('source')||((document.referrer&&new URL(document.referrer).origin===location.origin)?document.referrer:'');
 const sourceField=document.getElementById('nt-source-field');if(sourceField)sourceField.value=source;
 if(interest&&select&&Array.from(select.options).some(o=>o.value===interest))select.value=interest;
 if(select){const fields=document.getElementById('nt-commission-fields');const sync=()=>{if(fields)fields.hidden=select.value!=='commission';};select.addEventListener('change',sync);sync();}
 document.querySelectorAll('.nt-desktop-nav a').forEach(link=>{if(link.pathname===location.pathname&&!link.hash)link.setAttribute('aria-current','page');});
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nt-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus();});});
 document.querySelectorAll('.nt-menu a').forEach(link=>link.addEventListener('click',()=>link.closest('details').removeAttribute('open')));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ntInit);else ntInit();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-gallery"] && !Shopify.designMode) return;
  try {
    
function ntArchiveInit(){
  document.querySelectorAll('.nt-gallery-section.nt-archive').forEach(section=>{
    const viewButtons=Array.from(section.querySelectorAll('[data-archive-mode]'));
    const filterButtons=Array.from(section.querySelectorAll('[data-filter]'));
    const cards=Array.from(section.querySelectorAll('[data-kind]'));
    const records=Array.from(document.querySelectorAll('[data-record-kind]'));
    const archiveSections=Array.from(document.querySelectorAll('[data-complete-archive]'));
    const storageKey='nottravis-work-archive';
    let saved={};
    try{saved=JSON.parse(localStorage.getItem(storageKey)||'{}')||{};}catch(error){saved={};}
    const update=(view,filter,store)=>{
      const activeView=viewButtons.some(button=>button.dataset.archiveMode===view)?view:'selected';
      const activeFilter=filterButtons.some(button=>button.dataset.filter===filter)?filter:'all';
      section.dataset.archiveView=activeView;
      section.dataset.activeFilter=activeFilter;
      section.classList.toggle('nt-archive--filtered',activeFilter!=='all');
      viewButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.archiveMode===activeView)));
      filterButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===activeFilter)));
      cards.forEach(card=>{card.hidden=activeFilter!=='all'&&card.dataset.kind!==activeFilter;const link=card.querySelector('.nt-work-image');if(link&&link.dataset.project&&link.dataset.largeImage)link.href=activeView==='index'?link.dataset.project:link.dataset.largeImage;});
      cards.filter(card=>!card.hidden).forEach(card=>{const img=card.querySelector('img');const link=card.querySelector('.nt-work-image');if(img&&link)img.sizes=Math.max(1,Math.round(link.getBoundingClientRect().width))+'px';});
      records.forEach(record=>record.hidden=activeFilter!=='all'&&record.dataset.recordKind!==activeFilter);
      archiveSections.forEach(archive=>{
        const visible=Array.from(archive.querySelectorAll('[data-record-kind]')).filter(record=>!record.hidden);
        archive.hidden=visible.length===0;
        const count=archive.querySelector('.nt-complete-archive__count');
        if(count){if(!count.dataset.label)count.dataset.label=count.textContent.trim().replace(/^\d+\s*/,'');count.textContent=visible.length+' '+count.dataset.label;}
      });
      if(store){try{localStorage.setItem(storageKey,JSON.stringify({view:activeView,filter:activeFilter}));}catch(error){}}
    };
    const requestedFilter=new URLSearchParams(window.location.search).get('filter');
    update(saved.view||'index',requestedFilter||(location.hash?'all':saved.filter)||'all',false);
    viewButtons.forEach(button=>button.addEventListener('click',()=>update(button.dataset.archiveMode,section.dataset.activeFilter,true)));
    filterButtons.forEach(button=>button.addEventListener('click',()=>update(section.dataset.archiveView,button.dataset.filter,true)));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ntArchiveInit);else ntArchiveInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-project"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-project-viewer]').forEach(viewer=>{
 const panels=[...viewer.querySelectorAll('[data-project-panel]')], controls=viewer.querySelector('.nt-project-view-buttons');
 if(!controls||panels.length<2)return;
 panels.slice(1).forEach(panel=>panel.hidden=true);
 controls.hidden=false;
 controls.addEventListener('click',event=>{
  const button=event.target.closest('[data-project-view]');if(!button)return;
  controls.querySelectorAll('button').forEach(control=>control.setAttribute('aria-pressed',String(control===button)));
  panels.forEach(panel=>panel.hidden=panel.dataset.projectPanel!==button.dataset.projectView);
 });
});
document.querySelectorAll('[data-print-sheet]').forEach(button=>button.addEventListener('click',()=>window.print()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-selected-work"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cage-viewer]').forEach(viewer=>{
  const panels=[...viewer.querySelectorAll('[data-cage-panel]')];
  const controls=viewer.querySelector('.nt-selected-switch');
  if(panels.length<2||!controls)return;
  controls.hidden=false;
  const show=view=>{panels.forEach(panel=>panel.hidden=panel.dataset.cagePanel!==view);controls.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.cageView===view)));};
  show('detail');
  controls.addEventListener('click',event=>{const button=event.target.closest('[data-cage-view]');if(button)show(button.dataset.cageView);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-xoxo-film"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nt-xoxo-film]').forEach(frame=>{
  const video=frame.querySelector('video');
  const play=frame.querySelector('.nt-xoxo-film-play');
  if(!video||!play||frame.dataset.ready)return;
  frame.dataset.ready='true';
  video.controls=false;
  play.hidden=false;
  play.addEventListener('click',()=>{
    video.controls=true;
    play.hidden=true;
    video.play().catch(()=>{video.controls=true;play.hidden=false;});
  });
  video.addEventListener('error',()=>{video.controls=true;play.hidden=true;});
});

  } catch(e) { console.error(e); }
})();
})();
